<template>
  <div class="gold-shop-conditions">
    <v-modal block-scroll full no-background no-padding min-width="65rem">
      <template v-slot:activator="{ on }">
        <p class="mb-1" v-if="reqCountry.USA">{{ $t('components.Profile.goldShopConditions.watchVideoDesc') }}&nbsp;<a href="https://shopoffice.myswitplanet.com/?lang=en&amp;locale=en&amp;us=true" @click.prevent="on" target="_blank">https://shopoffice.myswitplanet.com/?lang=en&amp;locale=en&amp;us=true</a></p>
        <p class="mb-1" v-else-if="reqCountry.MEXICO">{{ $t('components.Profile.goldShopConditions.watchVideoDesc') }}&nbsp;<a href="https://shopoffice.myswitplanet.com/es-MX" @click.prevent="on" target="_blank">https://shopoffice.myswitplanet.com/es-MX</a></p>
      </template>

      <template v-slot:header>{{ $t('components.Profile.goldShopConditions.becomeAPartOfACommunity') }}</template>

      <template v-slot:default="{ containerHeight }">
        <div style="width: 100%;">
          <iframe v-if="reqCountry.USA" src="https://shopoffice.myswitplanet.com/?lang=en&amp;locale=en&amp;us=true" frameborder="0" :height="containerHeight - 7" width="100%"></iframe>
          <iframe v-else-if="reqCountry.MEXICO" src="https://shopoffice.myswitplanet.com/es-MX" frameborder="0" :height="containerHeight - 7" width="100%"></iframe>
        </div>
      </template>
    </v-modal>

    <p class="my-1">{{ $t('components.Profile.goldShopConditions.agreeWithTermsDesc') }}</p>
    <p class="mt-1 mb-2">
      <v-modal block-scroll :full="!screen.breakPoint.tabPort" :no-background="!screen.breakPoint.tabPort" no-padding min-width="65rem">
        <template v-if="reqCountry.USA" v-slot:activator="{ on }">
          - <a href="/statics/documents/myswitplanet-goldshop-contract.html" @click.prevent.stop="on">{{ $t('components.Profile.goldShopConditions.goldShopAgreement') }}</a> <br>
        </template>
        <template v-else-if="reqCountry.MEXICO" v-slot:activator="{ on }">
          - <a href="/statics/documents/myswitplanet-goldshop-contractMX.html" @click.prevent.stop="on">{{ $t('components.Profile.goldShopConditions.goldShopAgreement') }}</a> <br>
        </template>

        <template v-slot:header>{{ $t('components.Profile.goldShopConditions.goldShopAgreement') }}</template>

        <template v-if="reqCountry.USA" v-slot:default="{ containerHeight }">
          <div style="width: 100%;">
            <iframe src="/statics/documents/myswitplanet-goldshop-contract.html" frameborder="0" :height="containerHeight - 7" width="99%"></iframe>
          </div>
        </template>
        <template v-else-if="reqCountry.MEXICO" v-slot:default="{ containerHeight }">
          <div style="width: 100%;">
            <iframe src="/statics/documents/myswitplanet-goldshop-contractMX.html" frameborder="0" :height="containerHeight - 7" width="99%"></iframe>
          </div>
        </template>
      </v-modal>
    </p>
    <p class="my-1">
      <v-checkbox
        :label="label"
        :type="type"
        :val="val"
        v-model="model"
        :disabled="disabled"
      >
      </v-checkbox>
    </p>
  </div>
</template>

<script>
import vModal from '@/ui/modals/vModal'
import vCheckbox from '@/ui/controls/vCheckbox'

import screen from '@/mixins/screen'

export default {
  components: {
    vModal,
    vCheckbox
  },

  mixins: [screen],

  props: {
    label: {
      type: String,
      default: null
    },

    type: {
      type: String,
      default: null
    },

    val: {
      type: [Number, String],
      default: null
    },

    value: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    reqCountry: {
      type: Object,
      default: () => {
        return {
          /**
           * @return {Boolean}
           */
          USA: false,
          RUSSIA: false,
          BELARUS: false,
          KAZAKHSTAN: false,
          UKRAINE: false,
          MOLDOVA: false,
          MEXICO: false
        }
      }
    }
  },

  computed: {
    model: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
